import { createStyles, Theme } from '@nelnet/unifi-components-react';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const styles = ({ breakpoints, spacing, palette }: Theme) =>
  createStyles({
    container: {
      backgroundColor: palette.background.paper,
      position: 'relative',
      margin: `0 ${spacing(1)}px`,
      [breakpoints.up('md')]: {
        padding: '2rem 0 5rem',
        margin: `0 ${spacing(8)}px ${spacing(8)}px ${spacing(8)}px`,
      },
    },
    direction: {
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      padding: `0 ${spacing(1)}px`,
      [breakpoints.up('sm')]: {
        flexDirection: 'row-reverse',
      },
      [breakpoints.up('md')]: {
        flexWrap: 'nowrap',
        padding: `0 ${spacing(4)}px`,
      },
    },
    asideContainer: {
      margin: '1rem auto',
      flexDirection: 'row',
      maxWidth: '28rem',
      [breakpoints.up('md')]: {
        margin: 0,
        position: 'sticky',
        top: '2rem',
      },
    },
    boldDivider: {
      backgroundColor: '#73777F',
    },
  });

export default styles;
